import {useSelector,useDispatch} from 'react-redux'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {useEffect,useState} from 'react'
import {useGymTrainers} from '../../users/hooks'
import {capitalize,getTrainerParam,envAwarePost} from '../../../util/util'
import {copyProgram,selectCopyModal,setCopyModal} from '../../programs/programsSlice'
import {useHistory} from 'react-router-dom'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Select from "react-select"
import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'
import GymMultiSelect from '../../GymMultiSelect/GymMultiSelect'

const CorporateCopyOptions = ()=>{
    const dispatch = useDispatch()
    const statusDispatch = useApiStatusDispatch()
    const [gymLoadingStatus,setGymLoadingStatus] = useState('pending')
    const [gyms,setGyms] = useState([])
    const [selectedGyms,setSelectedGyms] = useState([])
    const [copyStatus,setCopyStatus] = useState('idle')
    const [selectAll,setSelectAll] = useState(false)
    const {program_id} = useSelector(selectCopyModal)
    const statusPost = useApiStatusEnvAwarePost()

    //get all gyms
    useEffect(()=>{
        envAwarePost('api/users/',{action:'getAllGyms'}).then(res=>{
            setGymLoadingStatus('idle')
            if(res.success === '1'){
                setGyms(res.data)
            }else{
                window.alert(res.message)
            }
        })
    },[])

    const handleCopyProgram = () => {
        const tgt_users = (
            selectAll
            ? gyms.map(g=>g.user_id_number)
            : selectedGyms.map(g=>g.value)
        )
        setCopyStatus('pending')
        statusDispatch(
            copyProgram({program_id,tgt_users}),
            'program',
            'copi'
        ).then(res=>{
            setCopyStatus('idle')
            setSelectAll(false)
            setSelectedGyms([])
            dispatch(setCopyModal({show:false}))
        })
    }

    return (
        <div>
            <hr className="my-2"/>
            <div className="text-center">Copy to Centers</div>
            <GymMultiSelect 
                disabled={copyStatus==='pending'}
                onChange={setSelectedGyms}
            />
            <Button 
                disabled={(selectedGyms.length === 0 && !selectAll)||copyStatus==='pending'}
                onClick={handleCopyProgram}
                className="mt-2" 
                block 
                variant="outline-primary" 
                size="small"
            >
                Copy to selected centers {copyStatus==='pending'&&<Spinner animation="border" size="sm"/>}
            </Button>
        </div>
    )
}

const CopyModal = ()=>{
	const dispatch = useDispatch()
	const {show,program_id} = useSelector(selectCopyModal)
	const user = useSelector(state=>state.users.current_user)
    const partOfGym = parseInt(user.gym_id) !== 0
	const history = useHistory()
	const statusDispatch = useApiStatusDispatch()
	const {trainers} = useGymTrainers()
	const [copyStatus,setCopyStatus] = useState('idle')
    const [selectedTrainer,setSelectedTrainer] = useState(null)
    const trainer = getTrainerParam()
    const trainerParam = trainer ? `trainer=${trainer}` : ''
    const isCorporateAccount = user.account_type === 'chain'

    const program = useSelector(state=>state.programs.programs.entities[program_id])
    
    const handleCopyProgram = (tgt_user_id_number,edit=false) => {
        setCopyStatus('pending')
        statusDispatch(copyProgram({program_id,tgt_user_id_number}),'program','create')
        .then(({payload:{success,data}}) => {
            setCopyStatus('idle')
            dispatch(setCopyModal({show:false}))
            if (success === '1'&&edit) {
                history.push(`/program-editor?id=${data.program_id}&${trainerParam}`)
            }
        })
    }

    const toggleCopyModal = ()=>{
    	dispatch(setCopyModal({show:!show}))
    }

	return (
		<Modal 
            onHide={toggleCopyModal}
            show={show}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="font-weight-normal">
                    Copy: {program?.programName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Button 
                    onClick={()=>{
                        handleCopyProgram(user.user_id_number)
                    }}
                    disabled={copyStatus === 'pending'}
                    variant="outline-primary" 
                    className="mb-2" 
                    block
                >
                    Copy {user.gym_id !== '0' ?`To My ${capitalize(user.account_type)} Account `:''}<br/> <small>(makes a duplicate you can edit later)</small>
                </Button>
                <Button 
                    onClick={()=>{handleCopyProgram(user.user_id_number,true)}}
                    disabled={copyStatus === 'pending'}
                    variant="outline-primary" 
                    block
                >
                    Copy & Edit <br/> <small>(makes a duplicate and takes you to the editor)</small>
                </Button>
                {partOfGym&&
                    <>
                        <div className="text-center text-muted my-1">- or -</div>
                        <small>Select a Trainer</small>
                        <Select 
                            onChange={setSelectedTrainer}
                            value={selectedTrainer}
                            options={
                                trainers
                                .filter(t => (
                                    parseInt(t.user_id_number)!== 
                                    parseInt(user.user_id_number)
                                )).map(t=>({
                                    value:t.user_id_number,
                                    label:t.user_name
                                }))
                            }
                        />
                        <div className="text-right">
                            <Button 
                                onClick={()=>{
                                    handleCopyProgram(selectedTrainer.value)
                                }}
                                disabled={!Boolean(selectedTrainer)||copyStatus==='pending'}
                                variant={
                                    Boolean(selectedTrainer) ?
                                    "outline-success" :
                                    "outline-secondary"
                                }
                                className="mt-2"
                                size="sm"
                            >
                                {
                                    Boolean(selectedTrainer)?
                                    'Copy to selected trainer' :
                                    'Select a trainer'
                                }
                            </Button>
                        </div>
                    </>
                }
                {copyStatus === 'pending'&&
                    <Alert variant="info" className="d-flex align-items-center mt-2 text-dark">
                        <Spinner animation="border" className="mr-2" size="sm"/>
                        Copying program (this may take a few minutes)
                    </Alert>
                }
                {isCorporateAccount&&<CorporateCopyOptions/>}
            </Modal.Body>
        </Modal>
	)
}

export default CopyModal